import AuditService from "../../services/auditConfigService";
import * as types from "./types";
import { initialState } from "./initialState";

const service = new AuditService();

export const getAuditList = (data) => {
  return (dispatch) => {
    dispatch({
      type: types.GET_AUDIT,
      payload: { ...initialState, loading: true },
    });
    service
      .getAuditList(data)
      .then((res) => {
        dispatch({
          type: types.GET_AUDIT,
          payload: { data: res.data.data, loading: false, status: 200 },
        });
      })
      .catch((error) => {
        dispatch({
          type: types.GET_AUDIT,
          payload: {
            ...initialState,
            message: error.message || "Error fetching data",
            loading: false,
            status: error.response?.status || 500,
          },
        });
      });
  };
};

